import { baseApi } from '@/api/core/baseApi';
import { unwrapApiResponse } from '@/api/patterns/crud';
import type { StepUpAuthResponse } from '../types';

export const stepUpAuthApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    stepUpAuthenticate: builder.mutation<StepUpAuthResponse, { password: string }>({
      query: ({ password }) => ({
        url: '/platform/step-up',
        method: 'POST',
        body: { password },
      }),
      transformResponse: unwrapApiResponse<StepUpAuthResponse>,
    }),
  }),
});

export const { useStepUpAuthenticateMutation } = stepUpAuthApi;
